const typeLabelMapping = {
    'classroom': 'Course',
    'conference': 'Conference',
    'online': 'e-Learning',
    'webinar': 'Webinar'
};

export const courseTypeToLabel = (courseType) => {
    return typeLabelMapping[courseType];
};


// WEBPACK FOOTER //
// ./services/courseTypeLabelMapper.js